"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "toscolano-maderno": {
    "ed0c6049": [{
      "hkey": "84ff3486",
      "slug": "gaino-pulciano",
      "name": "Gaino-Pulciano",
      "primary": true,
      "skipSearch": false
    }],
    "gaino": [{
      "hkey": "84ff3486",
      "slug": "gaino-pulciano",
      "name": "Gaino-Pulciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5d25a3d0": [{
      "hkey": "1cee0a6a",
      "slug": "toscolano-maderno",
      "name": "Toscolano-Maderno",
      "primary": true,
      "skipSearch": false
    }],
    "monte-maderno": [{
      "hkey": "1cee0a6a",
      "slug": "toscolano-maderno",
      "name": "Toscolano-Maderno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;